const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const Big = require("big.js");
const withOfficeErrorCatching = require("../../core/hoc/withOfficeErrorCatching");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const AT = require("../../core/vault/ActionTypes");
const Slots = require("../../core/vault/Slots");
const {
	atParentAccount,
	atParentPayments,
} = require("../../core/vault/StateCursors");
const OpsParentAcc = require("../vault/OpsParentAcc");
const OpsParentPayments = require("../vault/OpsParentPayments");
const OpsUser = require("../../core/vault/OpsUser");
const StringUtil = require("../../../shared/StringUtil");
const URLMake = require("../../../shared/URLMake");
const LoadGuard = require("../../core/view/LoadGuard");
const MinimalTabView = require("../../office/MinimalTabView");
const Editable = require("../../office/Editable");
const AddElement = require("../../office/AddElement");
const UnderlineView = require("../../office/UnderlineView");
const SubscriptionRow = require("./SubscriptionRow");
const NonSubscriptionStudentRow = require("./NonSubscriptionStudentRow");
const EditableAddress = require("./EditableAddress");
const EditableField = require("./EditableField");
const EditableCard = require("./EditableCard");
const Expandable = require("../../office/Expandable");
const ItemSummary = require("../../office/ItemSummary");
const ChangeEmailModal = require("../../office/modals/ChangeEmailModal");
const CopyTable = require("../../core/util/CopyTable");
const OfficeCopy = require("../../office/data/CopyTable");
const Cookie = require("../../core/util/Cookie");
const PrivacyBanner = require("../../core/view/PrivacyBanner");
const {MAX_SUBSCRIPTIONS_FOR_PARENT} = require("../../../shared/Constants");
const {KB_URLS} = require("../../../shared/KnowledgeBase");

const styles = require("./styles/PageAccount.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withOfficeErrorCatching(Component);
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(
		Component,
		(props, vaultState) => ({
			parentData: Slots.getValue(vaultState, Slots.table.parentData()),
			account: atParentAccount(vaultState).get(),
			payments: atParentPayments(vaultState).get(),
		}),
		{forLoggedIn: true}
	);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "PageAccount",

		propTypes: {
			section: PT.oneOf(["subscriptions", "information"]),
			extraInfo: PT.string, // optional extra info for the page
			user: PT.object.isRequired,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
			parentData: PT.object.isRequired,
			account: PT.object.isRequired,
			payments: PT.object.isRequired,
		},

		vaultEvents: {
			emailConfirmationSent: function() {
				this.setState({
					isLoading: false,
					confirmType: "emailSent",
				});
			},
			emailConfirmationSendError: function(error) {
				this.setState({
					isLoading: false,
					confirmType: error,
				});
			},
			attemptToAddStudent: function() {
				// Fired when user is redirected here after an error trying to add a student
				// Used to fire the nice error modal
				this.addStudent();
			},
			emailReceiptSuccess: function(orderID) {
				const {emailsSentForOrderID} = this.state;
				this.setState({
					emailsSentForOrderID: _.uniq(_.concat(emailsSentForOrderID, orderID)),
				});
			},
		},

		getDefaultProps: function() {
			return {
				section: "subscriptions",
			};
		},

		componentDidMount: function() {
			// Fetch basic user info from Platform, including new email. Do
			// this every time user comes to this page because new email
			// can get verified or expire.
			this.props.dispatch({
				type: AT.LOAD_USER_PLATFORM_BASICS_REQUEST,
			});
			// Pending book-level deferrals drive the "confirm your book level"
			// banner on each subscription row. User-scoped, so it doesn't depend
			// on the account/students load completing first.
			this.props.dispatch({
				type: AT.LOAD_BOOK_DEFERRALS_REQUEST,
			});
		},

		getInitialState: function() {
			return {
				isLoading: false,
				confirmType: null,
				emailsSentForOrderID: [],
			};
		},

		changePassword: function() {
			this.props.dispatch({
				type: AT.START_CHANGE_PASSWORD,
				opts: {forAccountPage: true},
			});
			this.setState(this.getInitialState());
		},

		changeEmail: function() {
			// SSO-only accounts (no password) cannot change email.
			if (!this.props.account.hasPassword) {
				return;
			}
			this.props.dispatch({
				type: AT.START_CHANGE_EMAIL,
				opts: {forAccountPage: true},
			});
			this.setState(this.getInitialState());
		},

		deleteCard: function() {
			this.props.dispatch({
				type: AT.DELETE_PARENT_CREDIT_CARD_REQUEST,
			});
		},

		resendConfirmation: function({newEmail, oldEmail}) {
			this.props.dispatch({
				type: AT.EMAIL_CONFIRMATION_REQUEST,
				email: newEmail,
				emailType: "change",
				oldEmail,
			});
			this.setState(this.getInitialState());
		},

		updateParentForm: function(section, vals) {
			this.props.dispatch({
				type: AT.SAVE_PARENT_FORM_REQUEST,
				section,
				vals,
			});
		},

		updateParentName: function(nameData) {
			this.props.dispatch({
				type: AT.SAVE_PARENT_NAME_REQUEST,
				...nameData,
			});
		},

		addStudent: function() {
			if (OpsParentAcc.canAddStudent(this.props.account)) {
				this.props.dispatch({
					type: AT.SET_PAGE,
					pageState: URLMake.state.forAccountSubscribe("add", null),
					addToHistory: true,
				});
			} else {
				//Show a message as to why they cannot add a student.
				const billingData = OpsParentAcc.getFormSection(
					this.props.account,
					"billing"
				);
				let messageType;
				if (_.get(billingData, "address1")) {
					const ownerCanPay = OpsParentAcc.hasPaymentMethod(this.props.account);
					messageType = ownerCanPay ? "ownerAddHitLimit" : "noOwnerPayment";
				} else {
					messageType = "noOwnerBilling";
				}
				this.props.dispatch({
					type: AT.SHOW_OFFICE_MESSAGE,
					messageType,
				});
			}
		},

		renderSubscriptions: function() {
			// parentData.students comes from the API endpoint /parent/students
			const {account, payments, user, parentData} = this.props;
			const students = account.students;

			//Order by displayName, then put inactive last
			let orderedStudents = _.sortBy(students, ["displayName"]);
			const activeStudents = _.filter(
				orderedStudents,
				s => s.subscription.active
			);
			orderedStudents = _.concat(
				activeStudents,
				_.filter(orderedStudents, s => !s.subscription.active)
			);
			const ownerCanPay = OpsParentAcc.hasPaymentMethod(account);
			const ownerCanReactivate = OpsParentAcc.canActivateStudent(account);
			const deferralsBySubID = _.keyBy(account.deferrals || [], d =>
				String(d.subscriptionID)
			);
			// to track the userIDs that are on BA
			const studentRows = orderedStudents.map((data, i) => {
				const renewPrice = OpsParentPayments.getUpcomingPrice(
					payments,
					data.subscription.subscriptionID
				);
				const startPasswordChange =
					this.props.extraInfo === `password${data.userID}`;
				const deferral =
					deferralsBySubID[String(data.subscription.subscriptionID)] || null;
				return (
					<SubscriptionRow
						key={data.userID}
						students={students}
						data={data}
						className={styles.userRow}
						startPasswordChange={startPasswordChange}
						renewPrice={renewPrice}
						ownerCanPay={ownerCanPay}
						ownerCanReactivate={ownerCanReactivate}
						user={user}
						deferral={deferral}
					/>
				);
			});

			// construct a list of students that don't have a parent relation on BA
			if (parentData.students) {
				const studentsWithoutBaParent = Object.entries(
					parentData.students
				).filter(([baUserIDString, student]) => {
					// only take students that are NOT in account.students
					const baUserId = parseInt(baUserIDString);
					return !students.some(s => s.userID === baUserId);
				});
				// now, create the rows on the page for the students don't have a parent relation on BA
				for (const [baUserIDString, student] of studentsWithoutBaParent) {
					const baUserID = parseInt(baUserIDString);
					// adding/renaming some needed fields for the student
					student.userID = baUserID;
					student.avatar = student.avatarData;
					studentRows.push(
						<NonSubscriptionStudentRow
							key={baUserID}
							students={students}
							data={student}
							className={styles.userRow}
							ownerCanPay={ownerCanPay}
							ownerCanReactivate={ownerCanReactivate}
						/>
					);
				}
			}

			if (activeStudents.length < MAX_SUBSCRIPTIONS_FOR_PARENT) {
				studentRows.unshift(
					<div key="add" className={styles.userRow}>
						<AddElement
							className={styles.addStudent}
							onAdd={this.addStudent}
							addText="Add Student"
						/>
					</div>
				);
			}

			return studentRows;
		},

		renderAccountInfo: function() {
			const {user, account} = this.props;
			const contact = OpsParentAcc.getFormSection(account, "contact");
			// Email used to log in
			const userEmail = _.get(user, "model.email");
			// Email in contact form (newly updated email, if recently changed)
			const newEmail = _.get(user, "model.newEmail") || userEmail;
			const accountEmail = contact.email;
			// The email that should show on account
			const email = accountEmail !== userEmail ? accountEmail : newEmail;
			const confirmType = this.state.confirmType;

			const resendEl = confirmType ? (
				<div className={styles.passwordSmallDisabled}>
					{confirmType === "emailSent"
						? "Email sent."
						: CopyTable.forLoginError(confirmType)}
				</div>
			) : (
				<div
					className={styles.passwordSmall}
					onClick={() =>
						this.resendConfirmation({newEmail: email, oldEmail: userEmail})
					}
				>
					Resend confirmation email.
				</div>
			);
			const warning =
				email !== userEmail ? (
					<div>
						<div className={styles.warning}>
							{`Until you confirm your new email, you must sign in with ${userEmail} and all updates will be sent to ${userEmail}.`}
						</div>
						{resendEl}
					</div>
				) : null;

			const firstName = _.get(user, "model.firstName", "");
			const lastName = _.get(user, "model.lastName", "");
			const firstNameText = firstName
				? "First Name: " + firstName
				: "Add first name";
			const lastNameText = lastName
				? "Last Name: " + lastName
				: "Add last name";

			let phoneText = "No phone on file";
			if (contact.phone) {
				phoneText = "Phone: " + contact.phone;
			}

			return (
				<div className={styles.account}>
					<div className={styles.sectionTitle}>Account</div>
					<EditableField
						title="Update First Name"
						placeholder="Enter first name"
						onUpdate={newFirstName =>
							this.updateParentName({firstName: newFirstName})
						}
						fieldType="firstName"
						text={firstNameText}
					/>
					<EditableField
						title="Update Last Name"
						placeholder="Enter last name"
						onUpdate={newLastName =>
							this.updateParentName({lastName: newLastName})
						}
						fieldType="lastName"
						text={lastNameText}
					/>
					{account.hasPassword ? (
						<Editable
							className={styles.editable}
							onClick={this.changeEmail}
							text={email}
						/>
					) : (
						<div>
							<Editable className={styles.editable} hideControls text={email} />
							<div className={styles.ssoEmailNote}>
								Email cannot be changed for accounts created with Google or
								another sign-in provider.
							</div>
						</div>
					)}
					{warning}
					<EditableField
						title="Update Phone Number"
						placeholder="Enter new phone number"
						onUpdate={phone => this.updateParentForm("contact", {phone})}
						fieldType="phone"
						text={phoneText}
					/>
					{account.hasPassword && (
						<div
							className={styles.password}
							onClick={evt => this.changePassword()}
						>
							Change Password
						</div>
					)}
				</div>
			);
		},

		renderBillingInfo: function() {
			const {account} = this.props;
			const billing = OpsParentAcc.getFormSection(account, "billing");
			const shownCC = account.shownCC || {};
			const startCardOpen = this.props.extraInfo === `paymentMethod`;
			const startBillingOpen = this.props.extraInfo === "billing";
			const cardEl = _.get(billing, "address1") ? (
				<EditableCard
					{...shownCC}
					onUpdate={card => this.updateParentForm("creditCard", card)}
					onDelete={this.deleteCard}
					startOpen={startCardOpen}
				/>
			) : null;
			return (
				<div className={styles.billing}>
					<div className={styles.sectionTitle}>Billing</div>
					<EditableAddress
						className={styles.editAddress}
						initialAddress={billing}
						addressType="billing"
						startOpen={startBillingOpen}
						onUpdate={address => this.updateParentForm("billing", address)}
					/>
					<br />
					<div className={styles.warningText}>
						If updating your credit card, billing address MUST be updated first.
					</div>
					<br />
					{cardEl}
				</div>
			);
		},

		renderShippingInfo: function() {
			const shipping = OpsParentAcc.getFormSection(
				this.props.account,
				"shipping"
			);
			return (
				<div className={styles.shipping}>
					<div className={styles.sectionTitle}>Shipping</div>
					<EditableAddress
						className={styles.editAddress}
						initialAddress={shipping}
						addressType="shipping"
						onUpdate={address => this.updateParentForm("shipping", address)}
					/>
				</div>
			);
		},

		renderEmailReceiptButton: function(paymentInfo) {
			const {orderID} = paymentInfo;
			if (!orderID) return null;

			const {emailsSentForOrderID} = this.state;
			if (emailsSentForOrderID.includes(orderID)) {
				return <span className={styles.emailReceiptStatus}>Email sent!</span>;
			}

			const onClick = e => {
				e.stopPropagation(); // prevent expandable from opening
				this.props.dispatch({
					type: AT.EMAIL_RECEIPT_REQUEST,
					orderID,
				});
			};

			return (
				<button className={styles.emailReceiptButton} onClick={onClick}>
					<img
						src="/assets/images/elements/email/email.svg"
						alt=""
						className={styles.emailReceiptButtonIcon}
					/>
					Email Receipt
				</button>
			);
		},

		getPaymentRow: function(paymentInfo, hideTax) {
			const {orderID, date, total, tax, upgradeInfo} = paymentInfo;
			let topShown = total;
			if (hideTax && Big(tax).gt(0)) {
				topShown = Big(total)
					.minus(tax)
					.toFixed(2);
			}
			const emailReceiptButton = this.renderEmailReceiptButton(paymentInfo);
			const rowTitle = (
				<>
					<div className={styles.paymentTitle}>
						<span>{date}</span>
						{/* hidden/shown in CSS */}
						<div className={styles.emailReceiptButtonContainer}>
							{emailReceiptButton}
						</div>
						<span>{StringUtil.toPrice(topShown)}</span>
					</div>
					{/* hidden/shown in CSS */}
					<div className={styles.emailReceiptButtonContainerMobile}>
						{emailReceiptButton}
					</div>
				</>
			);
			const expandableClasses = {
				main: styles.expandableMain,
				dropdown: styles.expandableDropdown,
				lSpacing: styles.expandableSpacing,
				content: styles.expandableContent,
			};
			return (
				<Expandable
					key={orderID || date}
					title={rowTitle}
					titleHeight="4rem"
					customClasses={expandableClasses}
				>
					<div className={styles.paymentDetails}>
						<ItemSummary
							itemsPrebundled={!!upgradeInfo}
							upgradeInfo={upgradeInfo}
							{...paymentInfo}
							hideTax={hideTax}
							showItemize={!hideTax}
						/>
					</div>
				</Expandable>
			);
		},

		renderCredit: function() {
			// Displays any credit the user may have from using coupons
			const {payments} = this.props;
			const credit = _.get(payments, "credit");

			return credit && _.toNumber(credit) !== 0 ? (
				<div className={styles.credit}>
					{`A coupon credit of ${StringUtil.toPrice(
						credit
					)} will be applied to your next automatic renewal payment.`}
				</div>
			) : null;
		},

		renderPayments: function() {
			// TODO: This is the most confusing function ever and we should rewrite it.

			const {payments} = this.props;
			const upcomingPayments = payments.upcoming.payments;
			const pastPayments = payments.past.payments;

			const sharedPaymentProps = {
				loadingView: "logo",
				logoColorType: "transparentGray",
				loadingViewClass: styles.paymentLoading,
				errorView: "refreshOffice",
				useSmallErrorView: true,
			};

			const upcomingLoadEl = (
				<LoadGuard
					identifier="parentAccountUpcomingPayments"
					status={this.props.payments.upcoming}
					requestLoad={this.loadUpcomingPayments}
					renderLoaded={() => upcomingEl}
					errorMessage={OfficeCopy.forAccountPageLoadError("upcomingPayments")}
					{...sharedPaymentProps}
				/>
			);
			const pastLoadEl = (
				<LoadGuard
					identifier="parentAccountPastPayments"
					status={this.props.payments.past.nextLoad}
					errorMessage={OfficeCopy.forAccountPageLoadError("pastPayments")}
					requestLoad={this.loadPastPayments}
					{...sharedPaymentProps}
				/>
			);

			let upcomingEl = null;
			let pastEl = pastLoadEl;

			const hasUpcoming = upcomingPayments && upcomingPayments.length;
			const hasPast = pastPayments && pastPayments.length;

			if (hasUpcoming) {
				//If there are upcoming payments, only display those occuring on the soonest date
				const soonestDatePayments = upcomingPayments.filter(
					p => p.date === upcomingPayments[0].date
				);

				upcomingEl = (
					<div>
						<div className={styles.paymentLabel}>
							Next Payment{" "}
							<span className={styles.paymentLabelNote}>
								(Based on your current subscription settings. Sales tax may
								apply.)
							</span>
						</div>
						{soonestDatePayments.map(s => this.getPaymentRow(s, true))}
					</div>
				);
			}

			if (hasPast) {
				// TODO: pastLoadEl, if always rendered by React, will repeatedly trigger
				// loads until all payments are loaded. We might want to find some way to
				// render it only when user scrolls to bottom, or maybe better, dispatch
				// the next load action only when the user scrolls to bottom.
				pastEl = (
					<div>
						<div className={styles.paymentLabel}>Previous Payments</div>
						{pastPayments.map(s => this.getPaymentRow(s, false))}
						{pastLoadEl}
					</div>
				);
			}

			const paymentClass =
				!hasUpcoming && !hasPast ? styles.paymentsEmpty : styles.payments;

			return (
				<div className={paymentClass}>
					{upcomingLoadEl}
					{pastEl}
				</div>
			);
		},

		makeSection: function(title, content, extra = null) {
			return (
				<div className={styles.section} key={title}>
					<div className={styles.title}>
						<UnderlineView text={title} />
					</div>
					{extra}
					<div className={styles.content}>{content}</div>
				</div>
			);
		},

		loadParentAccount: function() {
			this.props.dispatch({
				type: AT.LOAD_PARENT_ACCOUNT_REQUEST,
			});
		},

		loadUpcomingPayments: function() {
			this.props.dispatch({
				type: AT.LOAD_PARENT_UPCOMING_PAYMENTS_REQUEST,
			});
		},

		loadPastPayments: function() {
			this.props.dispatch({
				type: AT.LOAD_PARENT_MORE_PAST_PAYMENTS_REQUEST,
			});
		},

		renderStudentsLoadGuard: function() {
			// Loads student data in the background, which also updates the top bar.
			const requestLoad = () =>
				this.props.dispatch({
					type: AT.LOAD_PARENT_DATA_SLOT_REQUEST,
				});
			return (
				<LoadGuard
					identifier="students"
					status={this.props.parentData}
					requestLoad={requestLoad}
					loadingView={null}
					errorView={null}
				/>
			);
		},

		renderSubTab: function() {
			if (!this.props.account.isOwner) {
				return (
					<div className={styles.notOwner}>
						This account is not a subscription owner.
					</div>
				);
			}

			// Need this data for showing the upcoming prices on each subscription.
			const upcomingLoadEl = (
				<LoadGuard
					identifier="parentAccountUpcomingPayments"
					status={this.props.payments.upcoming}
					requestLoad={this.loadUpcomingPayments}
				/>
			);
			const hasClassWalletCookie = Cookie.get("cw");
			const classWalletError = OfficeCopy.getSubscriptionsWarning(
				"classwallet",
				styles,
				{includeUpgradeText: true}
			);
			return (
				<div className={styles.tabInner}>
					{this.makeSection(
						"Subscriptions",
						this.renderSubscriptions(),
						hasClassWalletCookie ? (
							<div className={styles.warning}>{classWalletError}</div>
						) : null
					)}
					{upcomingLoadEl}
				</div>
			);
		},

		renderInfoTab: function() {
			const renderInfo = () => {
				if (!this.props.account.isOwner) {
					return (
						<div className={styles.notOwner}>
							This account is not a subscription owner.
						</div>
					);
				}
				const payments =
					this.props.payments.upcoming.payments.length ||
					this.props.payments.past.payments.length
						? this.makeSection(
								"Payments",
								this.renderPayments(),
								this.renderCredit()
						  )
						: this.renderPayments();
				return (
					<div>
						{this.makeSection(
							"Information",
							<div className={styles.infoWrapper}>
								{this.renderAccountInfo()}
								{this.renderBillingInfo()}
								{this.renderShippingInfo()}
							</div>
						)}
						{payments}
						<ChangeEmailModal
							user={this.props.user}
							account={this.props.account}
						/>
					</div>
				);
			};
			return (
				<div className={styles.tabInner}>
					<LoadGuard
						identifier="parentAccount"
						status={this.props.account}
						requestLoad={this.loadParentAccount}
						loadingView="logo"
						logoColorType="transparentGray"
						loadingViewClass={styles.tabLoad}
						errorView="refreshOffice"
						errorMessage={OfficeCopy.forAccountPageLoadError("account")}
						useSmallErrorView={true}
						renderLoaded={renderInfo}
					/>
				</div>
			);
		},

		renderTermsAndConditions: function() {
			if (!OpsUser.hasAcceptedTerms(this.props.user)) {
				return <PrivacyBanner pageType="account" />;
			}
			return;
		},

		render: function() {
			const {account} = this.props;
			const selectedTab = this.props.section === "subscriptions" ? 0 : 1;

			const subscriptions = (
				<LoadGuard
					identifier="parentAccount"
					status={account}
					requestLoad={this.loadParentAccount}
					loadingView="logo"
					logoColorType="transparentGray"
					loadingViewClass={styles.tabLoad}
					errorView="refreshOffice"
					errorMessage={OfficeCopy.forAccountPageLoadError("subscriptions")}
					useSmallErrorView={true}
					renderLoaded={this.renderSubTab}
				/>
			);

			const information = this.renderInfoTab();

			return (
				<div className={styles.main}>
					{this.renderTermsAndConditions()}
					<MinimalTabView
						title="Account"
						tabTitles={["Subscriptions", "Info \u0026 Payments"]}
						tabs={[subscriptions, information]}
						tabLinks={[
							URLMake.forAccount("subscriptions"),
							URLMake.forAccount("information"),
						]}
						selectedTab={selectedTab}
						underTabLink={
							this.props.section === "subscriptions"
								? KB_URLS.SUBSCRIPTIONS_OVERVIEW
								: KB_URLS.ACCOUNTS_OVERVIEW
						}
						underTabLinkClass={styles.guideLink}
						underTabLinkText={"Questions? Check out our Help Site."}
						disabled={!OpsUser.hasAcceptedTerms(this.props.user)}
					/>
					{this.renderStudentsLoadGuard()}
				</div>
			);
		},
	})
);
